export default "__VITE_ASSET__cc9abe5b__"